import type {ReelData, ReelSource, StateAware} from '../../types/types.ts';
import type {Article} from './article.ts';
import type {ItemState} from './item-state.ts';

export class Reel implements StateAware {
	readonly #state;
	id: string;
	title: string;
	description: string;
	tags: {
		displayName: string;
		urlPattern: string;
	}[];
	publishedAt: string;
	manifest?: {
		file: string;
		type: string;
	};
	article?: {
		id: string;
		url: string;
		remoteUrl: string;
		label: string;
	};
	sources: ReelSource[];
	posterUrl: string;
	sourceUrl: string;
	relatedArticle?: Article;

	constructor(data: ReelData, state: ItemState) {
		this.#state = state;
		this.id = data.id;
		this.title = data.title;
		this.description = data.description;
		this.tags = data.tags;
		this.publishedAt = data.publishedAt;
		this.manifest = data.manifest;
		this.article = data.article;
		this.sources = data.sources;
		this.posterUrl = data.posterUrl;
		this.sourceUrl = data.sourceUrl;
	}

	get cardLayouts() {
		return {
			desktop: {},
			mobile: {}
		};
	}

	get story() {
		return this.tags[0]?.displayName;
	}

	get listTitle() {
		return this.title;
	}

	get pretitle() {
		return '';
	}

	get intro() {
		return '';
	}

	get contentGroups() {
		return null;
	}

	get isArticleGroup() {
		return false;
	}

	get asset() {
		return {
			// TODO: Render image
			pictureHtml: ''
		};
	}

	get byline() {
		return null;
	}

	get category() {
		return this.tags[0]?.displayName;
	}

	get section() {
		return this.tags[0]?.displayName;
	}

	get permalink() {
		return `/reel/${this.id}`;
	}

	get groupBy() {
		return '';
	}

	get sortOrder() {
		// TODO: Use published?
		return -1;
	}

	createPermalink(id: string) {
		return `/reel/${id}`;
	}

	getState() {
		return this.#state;
	}

	get state() {
		return this.#state.state;
	}

	get starred() {
		return this.#state.starred;
	}

	get mobileProgress() {
		return this.#state.mobileProgress;
	}

	get desktopProgress() {
		return this.#state.desktopProgress;
	}
}
